export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_male_Cn.99cf5ce0.webp";